import { Box, Typography, ListItem, Checkbox } from '@mui/material'
import React from 'react'
import { CheckBoxIcon, CheckedBlueBoxIcon } from 'packages/eid-icons'
import { useTranslation } from 'react-i18next'
import InfoTooltip from '../InfoTooltip'
import styled from '@emotion/styled'
import { getInfoTooltipFieldsConfig, getInfoTooltipItems } from 'packages/core'

const DEFAULT_INFO_TOOLTIP_FIELDS = [
    { field: 'friendlyName', labelKey: 'Common_FriendlyName' },
    { field: 'description', labelKey: 'Common_Description' },
]

const ListItemBox = styled(ListItem)({
    display: 'flex',
    alignItems: 'center',
    padding: 0,
    marginBottom: '0.5rem',
    marginTop: '0.5rem',
    borderLeft: '.3rem solid transparent',
    height: '2rem',

    '&:hover': {
        backgroundColor: 'inherit',
    },
    '& span': {
        paddingTop: '0',
        paddingBottom: '0',
    },
    '& p': {
        width: '100%',
        padding: '0 0.5rem',

        borderRadius: '0.5rem',
        '&:hover': {
            backgroundColor: '#f1f1f4',
        },
    },
    '& .search-highlight2': {
        color: '#950167',
        fontWeight: 600,
        textDecoration: 'underline',
    },
})

const CheckboxStyles = styled(Checkbox)({
    '&:hover': {
        backgroundColor: 'transparent !important',
    },
})

const highlight = (text, searchKey) => {
    try {
        searchKey = new RegExp('(' + searchKey + ')', 'gi')
        return text.split(searchKey).map((o, i) =>
            i % 2 === 1 ? (
                <span className="search-highlight2" key={i}>
                    {o}
                </span>
            ) : (
                o
            ),
        )
    } catch (e) {
        return text
    }
}

const CheckBoxListItem = ({
    item,
    highlightSelected,
    handleToggle,
    checked,
    labelId,
    highlightText,
    showInfoTooltip,
}) => {
    const { t } = useTranslation()
    const infoTooltipFieldsConfig = (() => {
        const configFields = getInfoTooltipFieldsConfig()
        return configFields.length > 0
            ? configFields
            : DEFAULT_INFO_TOOLTIP_FIELDS
    })()
    const isChecked = (item) => {
        return !item ? false : Boolean(checked.find((c) => c.id === item.id))
    }

    return (
        <ListItemBox
            role={undefined}
            button
            disabled={item?.IsReadOnly}
            sx={{
                ...(highlightSelected &&
                    isChecked(item) && {
                        background: '#fafcff',
                        borderLeft: '0.3rem solid #0057A0',
                        color: '#000 !important',
                        '& .MuiBox-root': {
                            '& p': {
                                background: '#fff !important',
                                color: '#000 !important',
                            },
                        },
                    }),
            }}
        >
            <Box display="flex" alignItems="center">
                <Box>
                    <CheckboxStyles
                        onClick={(e) => {
                            handleToggle(item)
                        }}
                        edge="start"
                        color="primary"
                        icon={
                            <Box display="flex" alignItems="center">
                                <CheckBoxIcon />
                            </Box>
                        }
                        checkedIcon={
                            <Box display="flex" alignItems="center">
                                <CheckedBlueBoxIcon />
                            </Box>
                        }
                        checked={isChecked(item)}
                        tabIndex={-1}
                        disableRipple
                        disabled={item?.IsReadOnly}
                        disableFocusRipple
                        inputProps={{
                            'aria-labelledby': labelId,
                        }}
                    />
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <Typography
                        variant="body2"
                        style={{
                            fontSize: '1.3rem',
                            wordBreak: 'break-word',
                            wordWrap: 'break-word',
                            overflow: 'auto',
                            fontWeight: '700',
                        }}
                    >
                        {highlightText && highlightText.length
                            ? highlight(item.friendlyName, highlightText)
                            : item.friendlyName}
                    </Typography>
                    {showInfoTooltip && (
                        <InfoTooltip
                            items={getInfoTooltipItems(
                                item,
                                infoTooltipFieldsConfig,
                                t,
                            )}
                        />
                    )}
                </Box>
            </Box>
        </ListItemBox>
    )
}

export default CheckBoxListItem
